import { useContext, useEffect } from "react";
import { Field } from "react-final-form";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import Section from "../../common/section";
import FormContext from "../../common/wizardForm/FormContext";
import * as Validations from "../../common/form/validator";
import { ColorPicker, TextInput } from "../../common/fields";
import FileUpload from "../../common/fileUpload";
import PreLoginBanner from "../../../assets/images/pre_login_banner.png";
import * as GlobalConstants from "../../../constants/GlobalConstants";

// The colour the brand colour picker resets to, and the platform's own.
const DEFAULT_BRAND_COLOR = "#3b82f6";

export const EnterpriseForm = ({
  disabled = false,
  onLogoUpload,
  uploading,
  progress,
  fileName,
  record,
  onBannerUpload,
  bannerFileName,
  uploadDetails,
  onLogoClear,
  onBannerClear,
}) => {
  const formProvider = useContext(FormContext);

  useEffect(() => {
    if (disabled) {
      formProvider.change("name", record?.name);
      // A tenant that never chose a colour has none stored: keep the default
      // colour (the field is required, so a blank one blocks every save)
      formProvider.change("brandColor", record?.brandColor || DEFAULT_BRAND_COLOR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  const intl = useIntl();
  return (
    <Section title="branding_details">
      <div className="flex flex-column gap-2">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <FileUpload
              name="file"
              label="logo"
              fileType={GlobalConstants.IMAGE_UPLOAD_FILE_TYPES}
              isImage
              fileUrl={
                (record?.logo &&
                  `${new URL(
                    record?.logo,
                    process.env.REACT_APP_URL
                  ).toString()}`) ||
                null
              }
              uploading={uploading?.[fileName]}
              progress={progress?.[fileName] || 0}
              onUpload={onLogoUpload}
              readOnly={disabled}
              uploadDetails={uploadDetails?.[fileName]}
              onClear={onLogoClear}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <FileUpload
              name="banner_file"
              label="pre_login_banner"
              fileType={GlobalConstants.IMAGE_UPLOAD_FILE_TYPES}
              isImage
              fileUrl={
                (record?.preLoginBanner &&
                  `${new URL(
                    record?.preLoginBanner,
                    process.env.REACT_APP_URL
                  ).toString()}`) ||
                PreLoginBanner
              }
              uploading={uploading?.[bannerFileName]}
              progress={progress?.[bannerFileName] || 0}
              onUpload={onBannerUpload}
              readOnly={disabled}
              uploadDetails={uploadDetails?.[bannerFileName]}
              onClear={onBannerClear}
            />
          </div>
        </div>
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="name"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "name",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "name",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="preLoginMessage"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "pre_login_message",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "pre_login_message",
              })}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="brandColor"
              component={ColorPicker}
              label={intl.formatMessage({
                id: "brand_color",
              })}
              resetPossible
              disabled={disabled}
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

const mapStateToProps = (state) => ({
  uploading: state.uploads?.uploading,
  progress: state.uploads?.progress,
});

export default connect(mapStateToProps)(EnterpriseForm);
